module.exports = __webpack_public_path__ + "img/BASYS_Logo_Primary.3f8e6160.png";